/* resources/js/woocommerce/checkout/index.js */

/* Checkout – bundler */
import { mount as mountPhone } from './phone.js';
import { mount as mountLogin } from './loginModal.js';
import { mount as mountShip }  from './shippingToggle.js';

// ⬇️ haal de juiste named export op:
import { mountPostcodeACF as mountPostcode } from './postcodeLookup.js';

export function mount() {
  mountPhone?.();
  mountLogin?.();
  mountShip?.();
  mountPostcode?.();

  // (optioneel) description-hider voor .wk--no-desc
  (function(){
    const root = document.querySelector('.wk-checkout.wk--no-desc');
    if (!root) return;
    root.querySelectorAll('.acf-label .description, .acf-field .description, .acf-help, p.description')
        .forEach(n => (n.style.display = 'none'));
  })();
}

// ⬇️ zorg dat het ook echt draait
if (document.readyState !== 'loading') { mount(); }
else { document.addEventListener('DOMContentLoaded', mount); }
